import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const overlayClassName =
  "fixed inset-0 z-50 bg-black/60 backdrop-blur-sm fill-mode-forwards data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0";

/**
 * 요소 하단에 얹는 가로 점선 구분선(after: 가상요소). aside 우측 점선
 * (Layout.tsx)과 같은 radial-gradient 점 패턴을 가로로 눕힌 것 — CSS dashed
 * border 는 대시 간격 조절이 안 돼 이 방식을 쓴다. 붙이는 요소는 relative 여야 하며
 * 이 클래스에 relative 를 포함한다. 좌우 padding 과 무관하게 폭 전체에 그어진다.
 */
export const dottedDividerBottomClassName =
  "relative after:pointer-events-none after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:bg-[image:radial-gradient(circle,var(--color-border)_1px,transparent_1.2px)] after:bg-[length:8px_2px] after:bg-repeat-x after:opacity-60 after:content-['']";

/** description 은 TipTap 이 만든 HTML(`<p>…</p>`) 로 저장된다. 목록/툴팁처럼
 * 텍스트만 필요한 곳에서 태그가 그대로 보이지 않도록 plain text 로 변환한다. */
export function htmlToText(html: string): string {
  return new DOMParser()
    .parseFromString(html, "text/html")
    .body.textContent?.replace(/\s+/g, " ")
    .trim() ?? "";
}
